import type { ReactNode } from 'react';
import { Step, type StepProps } from '../step';
import { StepList } from './step-list';

interface StepListWrapperProps {
  steps: StepProps[];
  className?: string;
}

export function StepListWrapper({ steps, className }: StepListWrapperProps): ReactNode {
  return (
    <StepList className={className}>
      {steps.map(stepProps => (
        <Step key={stepProps.title} {...stepProps} />
      ))}
    </StepList>
  );
}
